


import LAOACS9643InternalJSON from '../env/laoacs/LAOACS-9643-internal.json';
import LAOACS9643ExternalJSON from '../env/laoacs/LAOACS-9643-external.json';
import LAOACS9543InternalJSON from '../env/laoacs/LAOACS-9543-internal.json';
import LAOACS9543ExternalJSON from '../env/laoacs/LAOACS-9543-external.json';
import LAOACS8543InternalJSON from '../env/laoacs/LAOACS-PROD-internal.json';
import LAOACS8543ExternalJSON from '../env/laoacs/LAOACS-PROD-external.json';


export const getEnvVariable = (envVariable) => {
    const ENV_PROFILE = process.env.REACT_APP_PROFILE || 'LAOACS-PROD-internal'
    if (envVariable)
        switch (ENV_PROFILE) {
            //LAOACS
            case 'LAOACS-9643-internal':
                return LAOACS9643InternalJSON[envVariable]
            case 'LAOACS-9643-external':
                return LAOACS9643ExternalJSON[envVariable]
            case 'LAOACS-9543-internal':
                return LAOACS9543InternalJSON[envVariable]
            case 'LAOACS-9543-external':
                return LAOACS9543ExternalJSON[envVariable]
            case 'LAOACS-PROD-internal':
                return LAOACS8543InternalJSON[envVariable]
            case 'LAOACS-PROD-external':
                return LAOACS8543ExternalJSON[envVariable]
            default: return LAOACS8543InternalJSON[envVariable]
        }
}